var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"milestone-reference-root-container"},[_vm._m(0),_vm._l((_vm.dataSource),function(item){return _c('milestone-event-item',{key:item.id,attrs:{"data-source":item}})})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"milestone-reference-head-container"},[_c('span',{staticStyle:{"font-size":"12px","font-weight":"500","color":"#000000","margin-bottom":"10px"}},[_vm._v("引用的里程碑事件")])])
}]

export { render, staticRenderFns }